<template>
  <div class="modal fade" :class="direction" :id="objectModalName.supplier" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.supplier)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.supplier)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">Dienstleister
                  <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
                </p>
                <span class="modal-title">{{supplier.name}}</span>
              </div>
            </div>
          </div>

        </div>

        <div class="card due-dates">
          <div class="card-body">
            <div class="row" v-if="supplier.id">
              <div class="col">
                <span>Name</span>
                <p>{{supplier.name}}</p>
              </div>
              <div class="col">
                <span>{{ $t('controller') }}</span>
                <p>{{supplier.responsible_department}}</p>
              </div>
              <div class="col">
                <span>{{ $t('av_audit_completed') }}</span>
                <p>{{supplier.checked}}</p>
              </div>
              <div class="col">
                <span>{{ $t('subcontractors_exist') }}</span>
                <p>{{supplier.subcontractor}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group row">
                    <div class="col-12">
                      <label class="col-form-label">Name<span class="text-danger">*</span></label>
                      <input class="form-control" v-model="supplier.name" placeholder="Name" autocomplete="off">
                      <span class="error-message text-danger" v-show="v$.supplier.name.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-8">
                      <label class="col-form-label">{{ $t('systems') }}</label>
                      <select class="form-control select select-systems" v-model="supplier.systems" v-select2>
                        <option value="">--------</option>
                        <option v-for="system in systems" :value="system.text">{{system.text}}</option>
                      </select>
                    </div>
                    <div class="col-4 dkl-checkbox">
                      <input class="form-check-input" type="checkbox" id="data_processor" v-model="supplier.data_processor" autocomplete="off">
                      <label class="form-check-label" for="data_processor">{{ $t('processor') }}</label>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('short_description') }}</label>
                      <textarea class="form-control" v-model="supplier.description"></textarea>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('responsible_department') }}</label>
                      <select class="form-control select select-single select-department allow-create" v-model="supplier.responsible_department" v-select2>
                        <option value="">--------</option>
                        <option v-for="department in departments" :value="department.text">{{department.text}}</option>
                      </select>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('purpose') }}<span class="text-danger">*</span></label>
                      <input class="form-control" v-model="supplier.purpose" autocomplete="off">
                      <span class="error-message text-danger" v-show="v$.supplier.purpose.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('receiving_party') }}</label>
                      <input class="form-control" v-model="supplier.place" autocomplete="off">
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('type_of_data') }}<span class="text-danger">*</span></label>
                      <select class="form-control select select-multiple select-data-type allow-create" v-model="supplier.data_type" v-select2>
                        <option value="">--------</option>
                        <option v-for="type in dataTypes" :value="type.text">{{type.text}}</option>
                      </select>
                      <span class="error-message text-danger" v-show="v$.supplier.data_type.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('legal_base.name') }}</label>
                      <textarea class="form-control" v-model="supplier.legal_base" autocomplete="off"></textarea>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">{{ $t('contract') }}<span class="text-danger">*</span></label>
                      <input class="form-control" v-model="supplier.contract" autocomplete="off">
                      <span class="error-message text-danger" v-show="v$.supplier.contract.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6 dkl-checkbox">
                      <input class="form-check-input" type="checkbox" id="checked" v-model="supplier.checked" autocomplete="off">
                      <label class="form-check-label" for="checked">AV Prüfung stattgefunden <a v-if="supplier.av_check_report" href="#">Prüfbericht</a></label>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Unterauftragnehmer vorhanden</label>
                      <input class="form-control" v-model="supplier.subcontractor" autocomplete="off">
                    </div>
                    <div class="col-6 dkl-checkbox">
                      <input class="form-check-input" type="checkbox"  id="subcontractor_checked" v-model="supplier.subcontractor_checked" autocomplete="off">
                      <label class="form-check-label" for="subcontractor_checked">Unterauftragnehmer genehmigt</label>
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Name des Dokuments</label>
                      <input class="form-control" v-model="supplier.document" autocomplete="off">
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Verantwortlicher</label>
                      <input class="form-control" v-model="supplier.responsible" autocomplete="off">
                    </div>
                  </div> <!-- end row -->

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Stand</label>
                      <input class="form-control" v-model="supplier.stand" />
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Speicherort</label>
                      <textarea class="form-control" v-model="supplier.storage_place"></textarea>
                    </div>
                  </div> <!-- end row -->
                  <!-- start attachments -->
                  <slot name="fileUpload"></slot>
                  <!-- end attachments -->
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveSupplier">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.supplier)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {mapMutations, mapState} from 'vuex'
  import service from '@/utils/request.js';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import { Uploader, Button } from 'vant';
import {CLOSED_STATUS, deepCopy, boolDisplay, initSelect2, closeWarning, ajaxErrorMessage} from '@/utils/index.js';
  import {objectModalName} from "@/utils/enums";

  export default {
      name: "DKLVendor",
      components: {
        'van-uploader': Uploader,
        'van-button': Button,
        datePicker,
      },
      props: {
        supplier: {
          type: Object,
          required: true
        },
        direction: {
          type: String,
          default: 'right'
        },
      },
      data() {
        return {
          newComment: '',
          objectModalName: objectModalName
        }
      },
      validations() {
        return {
          supplier: {
            name: {required, $lazy: true},
            data_type: {required, $lazy: true},
            purpose: {required, $lazy: true},
            contract: {required, $lazy: true},
          },
        }
      },
      setup() {
        return {
          v$: useVuelidate()
        }
      },
      watch:{
        supplier: {
          handler: function (newValue, oldVal) {
            if (!this.modalDirty) this.setModalDirty(true)
          },
          deep: true
        }
      },
      computed: {
        ...mapState({
          user: state => state.user,
          account: state => state.account,
          edit: state => state.app.edit,
          departments: state => state.account.departments,
          systems: state => state.account.systems,
          dataTypes: state => state.account.dataTypes,
          modalDirty: state => state.app.modalDirty,
        }),
      },
      mounted() {
        // Select 2
        initSelect2()
        $(`#${objectModalName.supplier}`).on('hidden.bs.modal', () => {
          this.setEdit(false)
        })
        $(`#${objectModalName.supplier}`).on('shown.bs.modal', (e) => {
          $(`#${objectModalName.supplier} .select-systems`).val(this.supplier.systems).trigger('change')
          $(`#${objectModalName.supplier} .select-department`).val(this.supplier.responsible_department).trigger('change')
          $(`#${objectModalName.supplier} .select-data-type`).val(this.supplier.data_type).trigger('change')
        })
      },
      beforeDestroy() {
        $(`#${objectModalName.supplier}`).off('shown.bs.modal')
        $(`#${objectModalName.supplier}`).off('hidden.bs.modal')
      },
      methods: {
        closeWarning,
        ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
        async saveSupplier() {
          const isValid = await this.v$.supplier.$validate()
          if (!isValid) {
            this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
            return false
          }
          const newSupplier = this.supplier.id == null ? true : false
          let url = 'todos/v1/create_supplier/'
          if (!newSupplier) url = `todos/v1/update_supplier/${this.supplier.id}/`
          if (this.supplier.customer == '') this.supplier.customer = this.account.name
          this.supplier.modified_by = this.user.username
          service.request({
            url: url,
            method: 'POST',
            responseType: 'json',
            data: this.supplier
          }).then(response => {
            this.setModalDirty(false)
            this.v$.$reset()
            this.$emit('supplierUpdated', response.data)
            $('#' + objectModalName.supplier).modal('hide')
            this.$vToastify.success('Dienstleister ist erfolgreich gespeichert!')
          }).catch(error => this.$vToastify.error(ajaxErrorMessage(error)))
        },
      }
    }
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}

</style>
